import { helpers } from "veritone-redux-common";
import _ from "lodash";
import { fromJS } from "immutable";
const { createReducer } = helpers;

export const namespace = "advertiser";
export const Status = {
  STATUS_INITIAL: 'initial',
  STATUS_LOADING: 'loading',
  STATUS_LOADED: 'loaded',
  STATUS_ERROR: 'error'
};

export const DeleteConnectionStatus = {
  SUCCESS: 'success',
  FAILED: 'failed',
  INIT: 'init',
};

export const FETCH_FOLDERS = "fetch folders";
export const ADD_ADVERTISER = "add advertiser";
export const REMOVE_ADVERTISER = "remove advertiser";
export const UPDATE_ADVERTISER = "update advertiser";
export const REMOVE_ADVERTISER_SAGA = "remove advertiser saga";
export const ADD_ADVERTISER_SAGA = "add advertiser saga";
export const ADD_ADVERTISER_WITHOUT_GA_INVITE_SAGA = "add advertiser without GA invite saga";
export const CHECK_GA_CONNECTION_SAGA = "check ga connection saga";
export const UPDATE_ADVERTISER_SAGA = "update advertiser saga";
export const UPDATE_CHART_DATA_ADVERTISER = "update chart data for advertiser";
export const UPDATE_CHART_DATA_ADVERTISER_SAGA =
  "update chart data for advertiser saga";
export const GET_ADVERTISER_SAGA = "get advertiser saga";
export const UPDATE_SELECTED_CHART_ADVERTISER = "update selected in chart";
export const GET_STATION_SAGA = "get station saga";
export const UPDATE_ADVERTISER_DETAIL = "update advertiser detail";
export const UPDATE_ADVERTISER_DETAIL_SAGA = "update advertiser detail saga";
export const LOAD_ADVERTISER = "load advertiser";
export const NEXT_STEP_SAGA = "next step saga";
export const NEXT_STEP = "next step";
export const BACK_STEP = "back step";
export const SET_STEP = `${namespace}/go to step`;
export const TOGGLE_DOWNLOAD = "toggle download";
export const GET_CALENDAR_DATA_SAGA = "get calendar data saga";
export const GET_CALENDAR_DATA = "get calendar data";
export const UPDATE_INFOMATION_FORM_REPORT = "update information form";
export const CHANGE_DATE_RANGE = "change date range";
export const GET_DATE_RANGE = "get date range";
export const CHOOSE_CAMPAIGN = "choose campaign";
export const REMOVE_CAMPAIGN = "remove campaign";
export const ADD_CAMPAIGN = "add campaign";
export const DUPLICATE_CAMPAIGN = "duplicate campaign";


export const LOAD_ADVERTISERS = `${namespace}/LOAD_ADVERTISERS`;
export const SET_ADVERTISERS = `${namespace}/SET_ADVERTISERS`;
export const UPDATE_ADVERTISER_PERMISSIONS = `${namespace}/UPDATE_ADVERTISER_PERMISSIONS`;
export const SET_ADVERTISER_PERMISSIONS = `${namespace}/SET_ADVERTISER_PERMISSIONS`;
export const SET_LOAD_ADVERTISERS_STATUS = `${namespace}/SET_LOAD_ADVERTISERS_STATUS`;
export const LOAD_ADVERTISER_LOGO = `${namespace}/LOAD_ADVERTISER_LOGO`;
export const GA4_INVITE_TO_CONNECT = `${namespace}/GA4_INVITE_TO_CONNECT`;
export const SEND_ALERT_ADVERTISER_CONNECTION = `${namespace}/SEND_ALERT_ADVERTISER_CONNECTION`;

export const SEND_INVITE = `${namespace}/SEND_INVITE`;
export const DISMISS_INVITE = `${namespace}/DISMISS`;

export const GET_WEBLOG_FILES = `${namespace}/GET_WEBLOG_FILES`;
export const UPDATE_CUTOVER_DATE = `${namespace}/UPDATE_CUTOVER_DATE`;

export const DELETE_GA4_CONNECTION = `${namespace}/DELETE_GA4_CONNECTION`;
export const GET_LIST_PIXEL = `${namespace}/GET_LIST_PIXEL`;
export const UPDATE_PIXEL_STATUS_BY_ID = `${namespace}/UPDATE_PIXEL_STATUS_BY_ID`;
export const CREATE_ADVERTISER_PIXEL = `${namespace}/CREATE_ADVERTISER_PIXEL`;
export const UPDATE_PIXEL = `${namespace}/UPDATE_PIXEL`;
export const UPDATE_STATUS = `${namespace}/UPDATE_STATUS`;

const defaultState = {
  status: Status.STATUS_INITIAL,
  selfStatus: Status.STATUS_INITIAL,
  teamStatus: Status.STATUS_INITIAL,
  unassignedStatus: Status.STATUS_INITIAL,
  byId: {},
  allIds: [],
  self: [],
  team: [],
  unassignedAdvertisers: [],
};

const advertiserReducer = createReducer(defaultState, {
  [SET_ADVERTISERS]: (state, action) => {
    const { advertisers } = action.payload;
    return {
      ...state,
      ...advertisers,
      byId: advertisers.byId
        ? {
            ...state.byId,
            ...advertisers.byId,
          }
        : state.byId,
      allIds: advertisers.allIds
        ? _.uniq([...state.allIds, ...advertisers.allIds])
        : state.allIds,
    };
  },

  [SET_LOAD_ADVERTISERS_STATUS]: (state, action) => {
    const { status } = action.payload;
    return {
      ...state,
      status,
    };
  },

  [SET_ADVERTISER_PERMISSIONS]: (state, action) => {
    const { advertiserId, owner, editors, viewers } = action.payload;

    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiserId]: {
          ...state.byId[advertiserId],
          owner: owner,
          editors: editors,
          viewers: viewers,
        },
      },
    };
  },

  [REMOVE_CAMPAIGN]: (state, action) => {
    const { campaign } = action.payload;
    const { campaign_id, advertiser_id } = campaign;
    const chooseCampaignId = _.get(state, [
      'byId',
      advertiser_id,
      'chooseCampaignId',
    ]);

    if (campaign_id === 'editing') {
      return state;
    }
    const campaignsByAdvertiserId = _.get(
      state,
      ['byId', advertiser_id, 'campaigns'],
      []
    );
    const remainingCampaigns = campaignsByAdvertiserId.filter(
      (item) => item && item.campaign_id !== campaign_id
    );
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiser_id]: {
          ...state.byId[advertiser_id],
          chooseCampaignId:
            chooseCampaignId === campaign_id ? null : chooseCampaignId,
          campaigns: remainingCampaigns,
        },
      },
    };
  },
  [ADD_CAMPAIGN]: (state, action) => {
    const { campaign } = action.payload;
    const { advertiser_id, campaign_id, campaign_name, end_date, timezoneSetting } = campaign;
    if (!advertiser_id || campaign_id === 'editing') {
      return state;
    }
    const campaignList = _.get(state.byId[advertiser_id], 'campaigns', []);
    const isShowConnectionNotice = _.get(
      state.byId[advertiser_id],
      'is_show_connection_notice',
      true
    );
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiser_id]: {
          ...state.byId[advertiser_id],
          is_show_connection_notice: isShowConnectionNotice,
          campaigns: [...campaignList, { campaign_id, campaign_name, end_date, timezone: timezoneSetting }],
        },
      },
    };
  },
  [DUPLICATE_CAMPAIGN]: (state, action) => {
    const { campaign } = action.payload;
    const { advertiser_id, campaign_id, campaign_name, end_date, timezoneSetting } = campaign;
    if (!advertiser_id || campaign_id === 'editing') {
      return state;
    }
    const campaignList = _.get(state.byId[advertiser_id], 'campaigns', []);
    const isShowConnectionNotice = _.get(
      state.byId[advertiser_id],
      'is_show_connection_notice',
      true
    );
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiser_id]: {
          ...state.byId[advertiser_id],
          is_show_connection_notice: isShowConnectionNotice,
          campaigns: [...campaignList, { campaign_id, campaign_name, end_date, timezone: timezoneSetting }],
        },
      },
    };
  },
  [ADD_ADVERTISER]: (state, action) => {
    const { advertiser } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiser.advertiser_id]: {
          ...advertiser,
        },
      },
      allIds: [...state.allIds, advertiser.advertiser_id],
      self: [...state.self, advertiser.advertiser_id],
    };
  },

  [REMOVE_ADVERTISER]: (state, action) => {
    const { advertiser_id: advertiserId } = action.payload.advertiser;
    const { allIds, self, team, byId, unassignedAdvertisers } = state;
    const allAds = allIds.filter((id) => id !== advertiserId);
    const selfAds = self.filter((id) => id !== advertiserId);
    const newAdvertiserState = { ...byId };
    delete newAdvertiserState[advertiserId];
    const teamAds =
      team &&
      team.map((item) => {
        const member = _.cloneDeep(item);
        member.advertisers = member.advertisers.filter(
          (id) => id !== advertiserId
        );
        return member;
      });
    const unassignedAds =
      unassignedAdvertisers &&
      unassignedAdvertisers.map((item) => {
        const user = _.cloneDeep(item);
        const advertisers = _.get(user, 'advertisers', []);
        user.advertisers = advertisers.filter((id) => id !== advertiserId);
        return user;
      });

    return {
      ...state,
      byId: {
        ...newAdvertiserState,
      },
      allIds: allAds,
      self: selfAds,
      team: teamAds,
      unassignedAdvertisers: unassignedAds,
      status: state.status,
    };
  },

  [UPDATE_ADVERTISER]: (state, action) => {
    const { advertiser } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiser.advertiser_id]: {
          ...state.byId[advertiser.advertiser_id],
          ...advertiser,
        },
      },
    };
  },

  [UPDATE_ADVERTISER_DETAIL]: (state, action) => {
    const { advertiser } = action.payload;
    const campaigns = advertiser.campaign || [];
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiser.advertiser_id]: {
          ...state.byId[advertiser.advertiser_id],
          ...advertiser,
          campaigns: campaigns.map((campaign) =>
            _.pick(campaign, ['campaign_id', 'campaign_name'])
          ),
        },
      },
    };
  },

  [UPDATE_CHART_DATA_ADVERTISER]: (state, action) => {
    const { advertiser } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiser.advertiser_id]: {
          ...state.byId[advertiser.advertiser_id],
          ...advertiser,
        },
      },
    };
  },

  [UPDATE_SELECTED_CHART_ADVERTISER]: (state, action) => {
    const { advertiserId, range, chartId, selected } = action.payload;
    const immutableState = fromJS(state);
    return immutableState
      .setIn(
        ['byId', advertiserId, 'chartData', range, chartId, 'selected'],
        selected
      )
      .toJS();
  },

  [SET_STEP]: (state, action) => {
    const { step } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        editing: {
          ...state.byId['editing'],
          activeStep: step,
        },
      },
    };
  },

  [LOAD_ADVERTISER]: (state, action) => {
    return {
      ...state,
      byId: {
        ...state.byId,
        [action.meta.advertiser_id]: {
          ...state.byId[action.meta.advertiser_id],
          ...action.payload,
        },
      },
    };
  },
  [TOGGLE_DOWNLOAD]: (state, action) => {
    const { advertiser_id } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiser_id]: {
          ...state.byId[advertiser_id],
          openReportStatus: !state.byId[advertiser_id].openReportStatus,
        },
      },
    };
  },
  [UPDATE_INFOMATION_FORM_REPORT]: (state, action) => {
    const { contactInfoReport, advertiserId } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiserId]: {
          ...state.byId[advertiserId],
          contactInfoReport: {
            ...(state.byId[advertiserId] || {}).contactInfoReport,
            ...contactInfoReport,
          },
        },
      },
    };
  },

  [CHOOSE_CAMPAIGN]: (state, action) => {
    const { campaignId, advertiserId } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiserId]: {
          ...state.byId[advertiserId],
          chooseCampaignId: campaignId,
        },
      },
    };
  },

  [UPDATE_PIXEL_STATUS_BY_ID]: (state, action) => {
    const { advertiserId, pixelId, status } = action.payload;
    if (!pixelId) {
      return state;
    }
    let advertiserPixelDetail = _.get(
      state,
      ['byId', advertiserId, 'advertiserPixelDetail'],
      []
    );
    const newAdvertiserPixelDetail = advertiserPixelDetail.map(
      (pixelDetail) => {
        if (pixelDetail.pixelId === pixelId) {
          return {
            ...pixelDetail,
            pixelLoadingStatus: status,
          };
        }
        return pixelDetail;
      }
    );
    return {
      ...state,
      byId: {
        ...state.byId,
        [advertiserId]: {
          ...state.byId[advertiserId],
          advertiserPixelDetail: newAdvertiserPixelDetail,
        },
      },
    };
  },
});

export const getWeblogFiles = (advertiserId) => ({
  type: GET_WEBLOG_FILES,
  payload: {
    advertiserId
  }
});

export const setAdvertiserPermissions = ({advertiserId, owner, editors, viewers}) => ({
  type: SET_ADVERTISER_PERMISSIONS,
  payload: {
    advertiserId,
    owner,
    editors,
    viewers
  }
})

export const setAdvertisers = (advertisers) => ({
  type: SET_ADVERTISERS,
  payload: {
    advertisers
  }
})

export const loadAdvertisers = () => ({
  type: LOAD_ADVERTISERS
})

export const setLoadAdvertisersStatus = (status) => ({
  type: SET_LOAD_ADVERTISERS_STATUS,
  payload: {
    status
  }
})

export const updateAdvertiserPermission = (advertiserId, selectedUsers) => ({
  type: UPDATE_ADVERTISER_PERMISSIONS,
  payload: {
    advertiserId,
    selectedUsers
  }
})

export const chooseCampaign = (advertiserId, campaignId) => ({
  type: CHOOSE_CAMPAIGN,
  payload: {
    advertiserId,
    campaignId
  }
});

export const updateInformationFormReport = (
  advertiserId,
  contactInfoReport
) => ({
  type: UPDATE_INFOMATION_FORM_REPORT,
  payload: {
    advertiserId,
    contactInfoReport
  }
});

export const removeAdvertiser = advertiser => ({
  type: REMOVE_ADVERTISER,
  payload: {
    advertiser
  }
});

export const removeAdvertiserSaga = (advertiser,isRedirect = true) => {
  return {
    type: REMOVE_ADVERTISER_SAGA,
    payload: {
      advertiser,
      isRedirect
    }
  };
};

export const addAdvertiser = advertiser => ({
  type: ADD_ADVERTISER,
  payload: {
    advertiser
  }
});

export const addAdvertiserSaga = (advertiser, emailInfo) => {
  return {
    type: ADD_ADVERTISER_SAGA,
    payload: {
      advertiser,
      emailInfo
    }
  };
};

export const addAdvertiserWithoutGAIniteSaga = (advertiser) => {
  return {
    type: ADD_ADVERTISER_WITHOUT_GA_INVITE_SAGA,
    payload: {
      advertiser
    }
  };
};

export const checkGaConnectionSaga = (advertiser) => {
  return {
    type: CHECK_GA_CONNECTION_SAGA,
    payload: {
      advertiser
    }
  }
}

export const updateAdvertiser = (advertiser, oldAdvertiser) => {
  return {
    type: UPDATE_ADVERTISER,
    payload: {
      advertiser,
      oldAdvertiser
    }
  };
};

export const updateAdvertiserSaga = (advertiser, oldAdvertiser, isEmailInfoRequired, allowRedirect = true) => {
  return {
    type: UPDATE_ADVERTISER_SAGA,
    payload: {
      advertiser,
      oldAdvertiser,
      isEmailInfoRequired,
      allowRedirect,
    }
  };
};
export const updateSelectedChartAdvertiser = ({
  advertiserId,
  range,
  chartId,
  selected
}) => {
  return {
    type: UPDATE_SELECTED_CHART_ADVERTISER,
    payload: {
      advertiserId,
      range,
      chartId,
      selected
    }
  };
};
export const loadChartDataAdvertiser = advertiser => {
  return {
    type: UPDATE_CHART_DATA_ADVERTISER,
    payload: {
      advertiser
    }
  };
};

export const loadChartDataAdvertiserSaga = (advertiser, campaign, dateRange) => {
  return ({
    type: UPDATE_CHART_DATA_ADVERTISER_SAGA,
    payload: {
      advertiser,
      campaign,
      dateRange
    }
  });
};

export const loadAdvertiserDetail = advertiser => ({
  type: UPDATE_ADVERTISER_DETAIL,
  payload: {
    advertiser
  }
});

export const loadAdvertiserDetailSaga = advertiser_id => ({
  type: UPDATE_ADVERTISER_DETAIL_SAGA,
  payload: {
    advertiser_id
  }
});

export const getAdvertiserSaga = (advertiserId, currentTab) => ({
  type: GET_ADVERTISER_SAGA,
  payload: { advertiserId, currentTab }
});

export const getStationSaga = advertiser => ({
  type: GET_STATION_SAGA,
  payload: { advertiser }
});

export const setStep = step => ({
  type: SET_STEP,
  payload: {
    step
  }
});

export const nextStepSaga = advertiser => {
  return {
    type: NEXT_STEP_SAGA,
    payload: {
      advertiser
    }
  };
};

export const loadAdvertiser = (advertiserId, loadingState) => ({
  type: LOAD_ADVERTISER,
  meta: { advertiser_id: advertiserId },
  payload: {
    ...loadingState
  }
});

export const loadAdvertiserLogo = (advertiserId) => ({
  type: LOAD_ADVERTISER_LOGO,
  payload: {
    advertiserId
  }
});

export const toggleDownload = advertiser_id => ({
  type: TOGGLE_DOWNLOAD,
  payload: {
    advertiser_id
  }
});

export const sendInvite = advertiser => ({
  type: SEND_INVITE,
  payload: {
    advertiser
  }
});

export const dismissInvite = (advertiser, isShowConnectionNotice) => ({
  type: DISMISS_INVITE,
  payload: {
    advertiser,
    isShowConnectionNotice
  }
})

export const ga4InviteToConnect = (advertiserId, inviteRecipientEmails, inviteMessage) => ({
  type: GA4_INVITE_TO_CONNECT,
  payload: {
    advertiserId,
    inviteRecipientEmails,
    inviteMessage
  }
});

export const sendAlertForAdvertiserConnection = (advertiserId, recipientEmails, message) => ({
  type: SEND_ALERT_ADVERTISER_CONNECTION,
  payload: {
    advertiserId,
    recipientEmails,
    message
  }
})

export const deleteGA4Connection = (advertiserId) => ({
  type: DELETE_GA4_CONNECTION,
  payload: {
    advertiserId
  }
});

export const getAdvertiserByFolderId = state => folderId => {
  const advertiserList = _.get(
    state,
    ["folder", "byId", folderId, "advertisers"],
    []
  );
  return advertiserList.map(advertiserId =>
    _.get(state, ["advertiser", "byId", advertiserId])
  );
};

export const updateCutoverDate = (advertiserId, newDate) => ({
  type: UPDATE_CUTOVER_DATE,
  payload: {
    advertiserId,
    newDate
  }
});

export const createAdvertiserPixel = (advertiserId, data) => ({
  type: CREATE_ADVERTISER_PIXEL,
  payload: {
    advertiserId,
    data
  }
});

export const getAdvertiser = state => advertiserId =>
  state.advertiser.byId[advertiserId] || {};

export const getAdvertisers = state => state.advertiser;

export const getNewAdvertiser = state =>
  state.advertiser.byId.new || { advertiser_id: "new" };

export const getSelfAdvertisers = state => {
  const selfAdvertisersId = _.get(state, [namespace, 'self'], []);
  const advertisersById = _.get(state, [namespace, 'byId'], []);

  const selfAdvertisers = [];
  selfAdvertisersId.forEach(id => {
      const advertiser = advertisersById[id];

      if (advertiser && _.get(advertiser, 'advertiser_id') !== 'editing') {
        selfAdvertisers.push(advertiser);
      }
    });
  return selfAdvertisers;
}

export const getTransitionDate = (state) => advertiserId => _.get(state, [namespace, 'byId', advertiserId, 'google_analytics_cutover_date']);

export const getListPixel = (advertiserId, pixelIds) => ({
  type: GET_LIST_PIXEL,
  payload: {
    advertiserId,
    pixelIds
  }
});

export const updatePixelStatusById = (advertiserId, pixelId, status) => ({
  type: UPDATE_PIXEL_STATUS_BY_ID,
  payload: {
    advertiserId,
    pixelId,
    status,
  }
});

export const updatePixel = (advertiserId, pixel) => ({
  type: UPDATE_PIXEL,
  payload: {
    advertiserId,
    pixel,
  }
});

export const updateAdvertiserStatus = (advertiser) => ({
  type: UPDATE_STATUS,
  payload: {
    advertiser
  
}});


export default advertiserReducer;
